<app-list2 listId="core-mapping-spreadsheet-view"
          (onLocalAction)="onLocalAction($event)"
          (onSingleItemOperation)="onSingleItemOperation($event)">
</app-list2>
